var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-24p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7849_153509",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7849_153509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "build",
    d: "M17.477 20.6038L11.177 14.273C10.8244 14.4256 10.466 14.5432 10.1018 14.6259C9.73751 14.7086 9.35104 14.75 8.94236 14.75C7.34514 14.75 5.98751 14.1909 4.86946 13.0729C3.75141 11.9548 3.19238 10.5972 3.19238 8.99998C3.19238 8.48331 3.25808 7.9894 3.38948 7.51825C3.5209 7.04712 3.70776 6.59873 3.95006 6.17308L7.54236 9.74615L9.68853 7.59998L6.13471 4.0269C6.56034 3.7846 7.00582 3.59454 7.47116 3.45673C7.93651 3.31891 8.42691 3.25 8.94236 3.25C10.5396 3.25 11.8972 3.80903 13.0153 4.92708C14.1333 6.04513 14.6923 7.40276 14.6923 8.99998C14.6923 9.42178 14.6526 9.81473 14.5731 10.1788C14.4936 10.5429 14.3744 10.8949 14.2154 11.2346L20.5462 17.5346C20.7206 17.7112 20.8077 17.9246 20.8077 18.1748C20.8077 18.4249 20.7213 18.6365 20.5483 18.8094L18.7326 20.6252C18.5596 20.7981 18.3507 20.8814 18.1058 20.875C17.861 20.8686 17.6514 20.7782 17.477 20.6038ZM18.1155 19.1039L19.0309 18.1885L12.3712 11.5288C12.652 11.1827 12.859 10.7888 12.9924 10.3471C13.1257 9.90543 13.1924 9.45639 13.1924 8.99998C13.1924 7.89099 12.7962 6.90957 12.0039 6.05573C11.2116 5.20188 10.209 4.78328 8.99616 4.79995L11.1635 6.9673C11.3443 7.14807 11.4347 7.35896 11.4347 7.59998C11.4347 7.84099 11.3443 8.05188 11.1635 8.23265L8.17506 11.2211C7.99429 11.4019 7.78339 11.4923 7.54236 11.4923C7.30134 11.4923 7.09045 11.4019 6.90968 11.2211L4.74233 9.05378C4.7449 10.3371 5.17632 11.3574 6.03658 12.1144C6.89683 12.8715 7.86542 13.25 8.94236 13.25C9.37997 13.25 9.81758 13.1849 10.2552 13.0548C10.6928 12.9247 11.093 12.7211 11.4558 12.4442L18.1155 19.1039Z",
    fill: "#A5ACB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.8c45f1f0899993aceac41af755957127.svg";
export { ForwardRef as ReactComponent };